export class SubmitApplicationToAgency {

    static $inject = ['$uibModal', 'applicationId']
    constructor(private $uibModal, private applicationId) { }

    execute = () => {
        return this.$uibModal.open({
            templateUrl: 'areas/action/submitApplicationToAgency/submitApplicationToAgencyModal.html',
            controller: SubmitApplicationToAgencyModalController,
            controllerAs: 'samCtrl',
            resolve: {
                applicationId: () => this.applicationId
            },
            backdrop: false
        }).result
    }
}
    

class SubmitApplicationToAgencyModalController {

    public alerts: Array<Object> = []
    public pendingRequest: boolean

    static $inject = ['dialogs', '$uibModalInstance', 'InterviewerReview', 'applicationId']
    constructor(private dialogs, private $uibModalInstance, private InterviewerReview, private applicationId) { }

    submit() {
        this.pendingRequest = true;
        this.InterviewerReview.submitToAgency({
            applicationId: this.applicationId
        }, {
                //do nothing
            }, (data) => {
                this.$uibModalInstance.close();
            }, (data) => {
                this.pendingRequest = false;
                this.alerts.push({ type: 'danger', status: data.status, messages: data.data })
            })
    }

    closeAlert = function (index) {
        this.alerts.splice(index, 1)
    }

    close() {
        this.$uibModalInstance.dismiss()
    }

}